export const COMPANY_SIZES = [
    { value: '1-10', label: '1-10 employees' },
    { value: '11-50', label: '11-50 employees' },
    { value: '51-200', label: '51-200 employees' },
    { value: '201-500', label: '201-500 employees' },
    { value: '500+', label: '500+ employees' },
] as const;

export const INDUSTRIES = [
    { value: 'SaaS', label: 'Software as a Service' },
    { value: 'E-commerce', label: 'E-commerce' },
    { value: 'FinTech', label: 'Financial Technology' },
    { value: 'HealthTech', label: 'Healthcare Technology' },
    { value: 'EdTech', label: 'Educational Technology' },
    { value: 'Other', label: 'Other' },
] as const;

export const EXPERIENCE_LEVELS = ['Junior', 'Mid', 'Senior'] as const;

export const WORK_TYPES = ['On-site', 'Remote', 'Hybrid'] as const;

export const COMPANY_ROUTES = {
    COMPANIES: '/companies',
    DASHBOARD: '/companies/dashboard',
    COMPANY_PROFILE: '/companies/profile',
    JOB_POSTINGS: '/companies/jobs',
    JOB_DETAILS: (jobId: string) => `/companies/jobs/${jobId}`,
    PROJECTS: '/companies/projects',
    PROJECT_DETAILS: (projectId: string) => `/companies/projects/${projectId}`,
    MESSAGES: '/companies/messages',
    DAVID_INBOX: '/companies/david-inbox',
    RECEIVED_APPLICATIONS: '/companies/applications',
    APPLICATIONS_REVIEW: '/companies/applications-review',
    ONBOARDING: '/companies/onboarding',
    HIRING_PREFERENCES: '/companies/hiring-preferences',
    JOB_POSTING_METHOD: '/companies/job-posting-method',
    JOB_POSTING: '/companies/job-posting',
    JOB_REVIEW: '/company/job-review',
    JOB_SUCCESS: '/companies/job-success',
    CANDIDATE_MATCHES: '/companies/candidate-matches',
    ALL_RECOMMENDATIONS: '/companies/all-recommendations',
    INVITE_TEAM: '/companies/invite-team',
} as const;

export const ONBOARDING_STEPS = [
    {
        number: 1,
        title: "Company Profile Setup",
        isActive: true,
        isCompleted: false
    },
    {
        number: 2,
        title: "Hiring Preferences",
        isActive: false,
        isCompleted: false
    },
    {
        number: 3,
        title: "Job Posting",
        isActive: false,
        isCompleted: false
    }
] as const;
